<block-ui id="main">
	<router-outlet></router-outlet>
</block-ui>
